import env from '@y2/environments';

export const getLinkWithHost = (linkPath: string) =>
  String(linkPath).startsWith('/')
    ? `${env.routes.mainSite}${linkPath}`
    : linkPath;
